<br><br><br><br><br><br><br><br>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <form class="bg-light p-3" 
        #postulanteForm="ngForm" 
        
        novalidate>

        {{ postulanteForm.value | json }}
        <hr>
        {{ postulante | json}}
        <hr>
        <span>Form Valido?: </span>{{ postulanteForm.form.valid}}
        <!--Address-->
        <!--<div ngModelGroup="address">
          <div class="form-group">
            <label for="">Street</label>
            <input type="text" class="form-control" name="street" ngModel>
          </div>
          <div class="form-group">
            <label for="">City</label>
            <input type="text" class="form-control" name="city" ngModel>
          </div>
          <div class="form-group">
            <label for="">State</label>
            <input type="text" class="form-control" name="state" ngModel>
          </div>
          <div class="form-group">
            <label for="">Postal Code</label>
            <input type="text" class="form-control" name="postalCode" ngModel>
          </div>
        </div>-->
        <!--END of Address-->

        <div class="form-group">
          <label for="name">Name</label>
          <input type="text" 
            name="namePostulante" 
            #name="ngModel" 
            required 
            [class.is-invalid]="name.invalid && name.touched" 
            class="form-control" 
            [(ngModel)]="postulante.name">
            <small class="text-danger" [class.d-none]="name.valid || name.untouched">Name is required</small>
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" name="email" class="form-control" [(ngModel)]=postulante.email>
        </div>
        <div class="form-group">
          <label for="phone">Phone</label>
          <input type="tel" 
            #phone="ngModel" 
            pattern="^\d{9}$"
            [class.is-invalid]="phone.invalid && phone.touched"
            name="phone" 
            class="form-control" 
            [(ngModel)]="postulante.phone">
        </div>
        <div class="form-group">
          <select name="interes"  class="custom-select" [(ngModel)]="postulante.interes">
            <option selected value="">Estoy interesado en</option>
            <option *ngFor="let interes of intereses">{{interes}}</option>
          </select>
        </div>
        <div class="mb-3">
          <label for="">Time Preference</label>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="turno" value="morning" [(ngModel)]="postulante.turno">
            <label class="form-check-label">Mañana (9AM 12PM)</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="turno" value="evening" [(ngModel)]="postulante.turno">
            <label class="form-check-label" for="timePreference">Tarde (5PM 8PM)</label>
          </div>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" name="promotion" [(ngModel)]="postulante.promotion">
          <label for="" class="form-check-label">Send me promotional offers</label>
        </div>
        <button [disabled]="postulanteForm.form.invalid" role="button" class="btn btn-primary" (click)='crearPostulante()' *ngIf="!postulante.id else elseBlock" >Guardar</button>
        <ng-template #elseBlock>
          <button class="btn btn-primary" role="button" (click)="actualizarPostulante()">Actualizar</button>
        </ng-template>
        
      </form>
    </div>
  </div>
</div>